export enum HatchName {
  ANGLE = "ANGLE",
  ANSI31 = "ANSI31",
  ANSI32 = "ANSI32",
  ANSI33 = "ANSI33",
  ANSI34 = "ANSI34",
  ANSI36 = "ANSI36",
  ANSI37 = "ANSI37",
  ANSI38 = "ANSI38",
  AR_B816 = "AR-B816",
  AR_B816C = "AR-B816C",
  AR_CONC = "AR-CONC",
  AR_RROOF = "AR-RROOF",
  AR_SAND = "AR-SAND",
  AR_RSHKE = "AR-RSHKE",
  ASBESTOS = "ASBESTOS",
  BRASS = "BRASS",
  BOX = "BOX",
  CONCRT = "CONCRT",
  CORK = "CORK",
  CROSS = "CROSS",
  DASH = "DASH",
  DOTS = "DOTS",
  EARTH = "EARTH",
  ETOILE_02 = "ETOILE-02",
  ETOILE_03 = "ETOILE-03",
  ETOILE_05 = "ETOILE-05",
  FLEX = "FLEX",
  GOST_GLASS = "GOST_GLASS",
  GOST_GROUND = "GOST_GROUND",
  GOST_WOOD = "GOST_WOOD",
  GRASS = "GRASS",
  GRATE = "GRATE",
  GRAVEL = "GRAVEL",
  GRILLE_13 = "GRILLE-13",
  GRILLE_16 = "GRILLE-16",
  HEX = "HEX",
  HONEY = "HONEY",
  HOUND = "HOUND",
  HUM = "HUM",
  INSUL = "INSUL",
  JIS_LC_8A = "JIS_LC_8A",
  OMBRE_08 = "OMBRE-08",
  MUDST = "MUDST",
  NET3 = "NET3",
  PANEL = "PANEL",
  SACNCR = "SACNCR",
  SWAMP = "SWAMP",
  TEXTURE = "TEXTURE",
  TRIANG = "TRIANG",
  ZIGZAG = "ZIGZAG",
  ANSI32_315_45 = "ANSI32-315-45",
}
export const DR_HATCHES: { name: HatchName; baseScale?: number }[] = [
  {
    name: HatchName.ANGLE,
    baseScale: 0.2,
  },
  {
    name: HatchName.ANSI31,
    baseScale: 0.2,
  },
  {
    name: HatchName.ANSI32,
    baseScale: 0.2,
  },
  {
    name: HatchName.ANSI33,
    baseScale: 0.2,
  },
  {
    name: HatchName.ANSI34,
    baseScale: 0.2,
  },
  {
    name: HatchName.ANSI36,
    baseScale: 0.2,
  },
  {
    name: HatchName.ANSI37,
    baseScale: 0.4,
  },
  {
    name: HatchName.ANSI38,
    baseScale: 0.4,
  },
  {
    name: HatchName.AR_B816,
    baseScale: 0.01,
  },
  {
    name: HatchName.AR_B816C,
    baseScale: 0.01,
  },
  {
    name: HatchName.AR_CONC,
    baseScale: 0.02,
  },
  {
    name: HatchName.AR_RROOF,
    baseScale: 0.08,
  },
  {
    name: HatchName.AR_SAND,
    baseScale: 0.04,
  },
  {
    name: HatchName.AR_RSHKE,
    baseScale: 0.01,
  },
  {
    name: HatchName.ASBESTOS,
    baseScale: 0.01,
  },
  {
    name: HatchName.BRASS,
    baseScale: 0.5,
  },
  {
    name: HatchName.BOX,
    baseScale: 0.2,
  },
  {
    name: HatchName.CONCRT,
    baseScale: 5,
  },
  {
    name: HatchName.CORK,
    baseScale: 0.4,
  },
  {
    name: HatchName.CROSS,
    baseScale: 0.4,
  },
  {
    name: HatchName.DASH,
    baseScale: 0.4,
  },
  {
    name: HatchName.DOTS,
    baseScale: 0.4,
  },
  {
    name: HatchName.EARTH,
    baseScale: 0.2,
  },
  {
    name: HatchName.ETOILE_02,
    baseScale: 5,
  },
  {
    name: HatchName.ETOILE_03,
    baseScale: 5,
  },
  {
    name: HatchName.ETOILE_05,
    baseScale: 5,
  },
  {
    name: HatchName.FLEX,
    baseScale: 0.2,
  },
  {
    name: HatchName.GOST_GLASS,
    baseScale: 0.2,
  },
  {
    name: HatchName.GOST_GROUND,
    baseScale: 0.2,
  },
  {
    name: HatchName.GOST_WOOD,
    baseScale: 0.2,
  },
  {
    name: HatchName.GRASS,
    baseScale: 0.2,
  },
  {
    name: HatchName.GRATE,
    baseScale: 0.8,
  },
  {
    name: HatchName.GRAVEL,
    baseScale: 0.2,
  },
  {
    name: HatchName.GRILLE_13,
    baseScale: 2,
  },
  {
    name: HatchName.GRILLE_16,
    baseScale: 2,
  },
  {
    name: HatchName.HEX,
    baseScale: 0.4,
  },
  {
    name: HatchName.HONEY,
    baseScale: 0.4,
  },
  {
    name: HatchName.HOUND,
    baseScale: 0.8,
  },
  {
    name: HatchName.HUM,
    baseScale: 0.9,
  },
  {
    name: HatchName.INSUL,
    baseScale: 0.4,
  },
  {
    name: HatchName.JIS_LC_8A,
    baseScale: 0.2,
  },
  {
    name: HatchName.OMBRE_08,
    baseScale: 0.2,
  },
  {
    name: HatchName.MUDST,
    baseScale: 0.2,
  },
  {
    name: HatchName.NET3,
    baseScale: 0.4,
  },
  {
    name: HatchName.PANEL,
    baseScale: 5,
  },
  {
    name: HatchName.SACNCR,
    baseScale: 0.8,
  },
  {
    name: HatchName.SWAMP,
    baseScale: 0.25,
  },
  {
    name: HatchName.TEXTURE,
    baseScale: 10,
  },
  {
    name: HatchName.TRIANG,
    baseScale: 0.4,
  },
  {
    name: HatchName.ZIGZAG,
    baseScale: 0.4,
  },
  {
    name: HatchName.ANSI32_315_45,
    baseScale: 10,
  },
];
